__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/8f4acfb3d275d1d156619663024d0a811d9b9656378bc4e78c79844a/";